import { flow, find } from "lodash/fp";
import moment from "moment";
import constants from "../../core/constants";
import { parsePrice } from "../../core/utils";

class ContractorInvoicePageTransform {
  constructor(Lists) {
    "ngInject";
    this.Lists = Lists;
    this.invoiceItemFields = [
      { name: "date", title: "Date" },
      { name: "amount", title: "Amount" },
      { name: "currency", title: "Currency" },
      { name: "type", title: "Type" },
      { name: "active", title: "Active" },
      { name: "contractor", title: "Contractor" },
      { name: "reference_file", title: "Download", isDownloadable: true },
    ];
  }
  justify(data) {
    const formatDate = (item) => {
      item.start_date = moment(item.start_date).format(constants.dateFormat);
      item.end_date = item.end_date
        ? moment(item.end_date).format(constants.dateFormat)
        : null;
      item.total_amount = parsePrice(item.total_amount);

      return item;
    };

    const formatStatus = (item) => {
      const findStatus = (listItem) => item.status === listItem.name;
      const statusObj = find(findStatus)(this.Lists.all.invoiceStatus);
      item.status = statusObj;
      return item;
    };
    return flow([formatDate, formatStatus])(data);
  }
}

export default ContractorInvoicePageTransform;



// WEBPACK FOOTER //
// ./src/pages/contractorInvoice/contractorInvoice.transforms.js